export const glUpdateTopic = 'glUpdateTopic';
export const glTouchMoveTopic = 'glTouchMoveTopic';
export const glTouchEndTopic = 'glTouchEndTopic';
export const glTouchStartTopic = 'glTouchStartTopic';
export const glTouchLeaveTopic = 'glTouchLeaveTopic';
export const glDragDirection = 'glDragDirection';

// Liquid ID
export const glPauseAnimation = 'glPauseAnimation';
export const glShowFace = 'glShowFace';
export const glFaceChange = 'glFaceChange';
export const glRemoveFace = 'glRemoveFace';
export const glClearFaces = 'glClearFaces';
export const glLiquidIDClick = 'glLiquidIDClick';
export const glLiquidEditMode = 'glLiquidEditMode';
export const glShowUIButtons = 'glShowUIButtons';
export const glLiquidIdExpandedPreview = 'glLiquidIdExpandedPreview';
export const glLiquidIDOrbitControls = 'glLiquidIdOrbitControls';
export const glLiquidIDRotate = 'glLiquidIDRotate';
export const glLiquidIDDraggingToFaceIndex = 'glLiquidIDDraggingToFaceIndex';
